import React from 'react';

/**
 * Etapas — passos de um fluxo. `atual` é o índice da etapa em curso; antes dele, feitas.
 * O passo atual leva aria-current="step".
 */
export default function Etapas({ etapas, atual, rotulo = 'Etapas' }) {
  return (
    <ol className="sj-etapas" style={{ '--etapas': etapas.length }} aria-label={rotulo}>
      {etapas.map((nome, i) => {
        const classes = ['sj-etapa', i < atual ? 'sj-etapa--feita' : ''].filter(Boolean).join(' ');
        return (
          <li key={nome} className={classes} aria-current={i === atual ? 'step' : undefined}>
            {nome}
          </li>
        );
      })}
    </ol>
  );
}
